export default __webpack_public_path__ + "static/media/buttons.7bcdd6ac.png";